module.exports = __webpack_public_path__ + "static/media/add-product-3.452a78a0.jpg";